import React from "react";
import {
  RefundRequestComponent,
  RefundRequestComponentType,
  RefundRequestComponentStatus,
} from "../../../common/types";
import { formatDateTime, formatCurrency, getComponentTypeLabel } from "../../utils";
import { Select } from "@glamcorner/components";
import { stringToRefundRequestComponentStatus } from "../../mappers";

interface RefundRequestComponentTableRowProps {
  component: RefundRequestComponent;
  statusOnChange: ({
    type,
    status,
  }: {
    type: RefundRequestComponentType;
    status: RefundRequestComponentStatus;
  }) => void;
  allChecklistItemsComplete: boolean;
}

export const RefundRequestComponentTableRow: React.FC<RefundRequestComponentTableRowProps> = ({
  component,
  statusOnChange,
  allChecklistItemsComplete,
}) => {
  const { type, amountInCents, processedAt, status } = component;
  const formattedProcessedAt = processedAt ? formatDateTime(processedAt) : "N/A";
  const selectOnChangeHandler = (newStatus: string) => {
    statusOnChange({ type, status: stringToRefundRequestComponentStatus(newStatus) });
  };
  const statuses = Object.values(RefundRequestComponentStatus).filter(k => k !== RefundRequestComponentStatus.Processing);
  const allowedToChangeStatus =
    allChecklistItemsComplete &&
    [RefundRequestComponentStatus.Unprocessed, RefundRequestComponentStatus.Failed].indexOf(status) > -1;

  return (
    <tr className="c-table__tr">
      <td className="c-table__cell">{getComponentTypeLabel(type)}</td>
      <td className="c-table__cell" style={{ width: 100 }}>
        {status}
      </td>
      <td className="c-table__cell c-table__cell--right">{formatCurrency(amountInCents)}</td>
      <td className="c-table__cell">{formattedProcessedAt}</td>
      <td className="c-table__cell">
        {allowedToChangeStatus && (
          <Select value={status} onChange={selectOnChangeHandler}>
            {statuses.map(s => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </Select>
        )}
      </td>
    </tr>
  );
};
